import { useNavigate } from 'react-router-dom';

const services = [
  {
    id: 'basic',
    name: '단기 작업',
    duration: '5시간',
    amount: 80000,
    orderId: () => `order_basic_${Date.now()}`,
    orderName: '단기 작업 (5시간)',
    description: '5시간 기준 단기 청소 인력 서비스',
    badge: '기본',
    highlight: false,
  },
  {
    id: 'standard',
    name: '청소 인력 서비스',
    duration: '10시간',
    amount: 150000,
    orderId: () => `order_standard_${Date.now()}`,
    orderName: '청소 인력 서비스 (10시간)',
    description: '10시간 기준 청소 인력 서비스',
    badge: '인기',
    highlight: true,
  },
  {
    id: 'premium',
    name: '청소 인력 서비스',
    duration: '12시간',
    amount: 200000,
    orderId: () => `order_premium_${Date.now()}`,
    orderName: '청소 인력 서비스 (12시간)',
    description: '12시간 기준 청소 인력 서비스',
    badge: '프리미엄',
    highlight: false,
  },
];

const CLIENT_KEY = 'test_ck_Z61JOxRQVEovazEWxN5Q8W0X9bAq';

export default function PaymentPage() {
  const navigate = useNavigate();

  const handlePayment = (service: typeof services[0]) => {
    const script = document.createElement('script');
    script.src = 'https://js.tosspayments.com/v1/payment';
    script.onload = () => {
      // @ts-expect-error TossPayments is loaded dynamically via script tag and not typed
      const tossPayments = window.TossPayments(CLIENT_KEY);
      tossPayments.requestPayment('카드', {
        amount: service.amount,
        orderId: service.orderId(),
        orderName: service.orderName,
        customerName: '고객',
        successUrl: `${window.location.origin}/payment/success`,
        failUrl: `${window.location.origin}/payment/fail`,
      }).catch((error: { code: string; message: string }) => {
        if (error.code !== 'USER_CANCEL') {
          alert(`결제 오류: ${error.message}`);
        }
      });
    };
    document.head.appendChild(script);
  };

  return (
    <div className="min-h-screen bg-[#FDFCFA] flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center space-x-2 cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center text-[#C4A574]">
              <i className="ri-hotel-bed-line text-2xl"></i>
            </div>
            <span className="text-lg font-bold text-gray-900">프리미엄 클린</span>
          </button>
          <button
            onClick={() => navigate('/')}
            className="flex items-center space-x-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            <span>홈으로 돌아가기</span>
          </button>
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="bg-[#FAF8F5] border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-6 py-3">
          <div className="flex items-center space-x-2 text-sm text-gray-500">
            <button onClick={() => navigate('/')} className="hover:text-[#C4A574] transition-colors cursor-pointer">홈</button>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900 font-medium">서비스 결제</span>
          </div>
        </div>
      </div>

      {/* Main */}
      <main className="flex-1 max-w-3xl mx-auto w-full px-6 py-16">
        {/* 페이지 제목 */}
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-[#FAF8F5] rounded-2xl flex items-center justify-center text-[#C4A574] mx-auto mb-6">
            <i className="ri-bank-card-line text-3xl"></i>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            청소 인력 서비스 결제
          </h1>
          <p className="text-gray-500 text-base leading-relaxed">
            서비스 이용 후 해당 상품을 선택하여 결제를 진행해 주세요
          </p>
        </div>

        {/* 서비스 카드 목록 */}
        <div className="space-y-5 mb-10">
          {services.map((service) => (
            <div
              key={service.id}
              className={`bg-white rounded-3xl shadow-md border-2 overflow-hidden transition-all duration-300 ${
                service.highlight ? 'border-[#C4A574]' : 'border-gray-100 hover:border-[#C4A574]'
              }`}
            >
              <div className="p-8 md:p-10">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                  {/* 서비스 정보 */}
                  <div className="flex items-start space-x-4">
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
                      service.highlight ? 'bg-[#C4A574] text-white' : 'bg-[#FAF8F5] text-[#C4A574]'
                    }`}>
                      <i className="ri-time-line text-2xl"></i>
                    </div>
                    <div>
                      <div className="flex items-center space-x-2 mb-1">
                        <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${
                          service.highlight
                            ? 'bg-[#C4A574] text-white'
                            : 'bg-[#FAF8F5] text-[#C4A574]'
                        }`}>
                          {service.badge}
                        </span>
                        <span className="text-sm text-gray-400">{service.duration}</span>
                      </div>
                      <h2 className="text-xl font-bold text-gray-900 mb-1">{service.name}</h2>
                      <p className="text-gray-500 text-sm">{service.description}</p>
                    </div>
                  </div>

                  {/* 금액 + 버튼 */}
                  <div className="flex flex-col items-end space-y-3 flex-shrink-0">
                    <div className="flex items-baseline">
                      <span className="text-4xl font-bold text-gray-900">
                        {service.amount.toLocaleString()}
                      </span>
                      <span className="text-xl text-gray-500 ml-1.5">원</span>
                    </div>
                    <button
                      onClick={() => handlePayment(service)}
                      className={`px-8 py-3.5 rounded-xl text-base font-bold transition-all shadow-md whitespace-nowrap cursor-pointer flex items-center space-x-2 ${
                        service.highlight
                          ? 'bg-[#C4A574] text-white hover:bg-[#B39564]'
                          : 'bg-gray-900 text-white hover:bg-gray-700'
                      }`}
                    >
                      <i className="ri-lock-line"></i>
                      <span>결제하기</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 결제 수단 안내 */}
        <div className="bg-[#FAF8F5] rounded-2xl p-6 border border-gray-100 mb-6">
          <p className="text-xs text-gray-500 mb-3 font-medium">결제 수단</p>
          <div className="flex flex-wrap items-center gap-3">
            <div className="flex items-center space-x-2 px-4 py-2 bg-white rounded-lg border border-gray-200 text-sm text-gray-700">
              <i className="ri-bank-card-2-line text-[#C4A574]"></i>
              <span>신용카드</span>
            </div>
            <div className="flex items-center space-x-2 px-4 py-2 bg-white rounded-lg border border-gray-200 text-sm text-gray-700">
              <i className="ri-exchange-dollar-line text-[#C4A574]"></i>
              <span>계좌이체</span>
            </div>
            <div className="flex items-center space-x-2 px-4 py-2 bg-white rounded-lg border border-gray-200 text-sm text-gray-700">
              <i className="ri-smartphone-line text-[#C4A574]"></i>
              <span>간편결제</span>
            </div>
          </div>
          <p className="text-center text-gray-400 text-xs mt-4 flex items-center justify-center space-x-1">
            <i className="ri-shield-check-line text-[#C4A574]"></i>
            <span>토스페이먼츠 PG를 통해 안전하게 결제됩니다</span>
          </p>
        </div>

        {/* 안내 사항 */}
        <div className="bg-[#FAF8F5] rounded-2xl p-6 border border-gray-100 mb-6">
          <div className="flex items-center space-x-2 mb-4">
            <i className="ri-information-line text-[#C4A574] text-lg"></i>
            <h3 className="text-sm font-bold text-gray-900">결제 전 확인사항</h3>
          </div>
          <ul className="space-y-2.5">
            {[
              '서비스 이용 후 해당 시간에 맞는 상품을 선택하여 결제해 주세요.',
              '서비스 제공일 전일 18시 이전 취소 시 전액 환불됩니다.',
              '서비스 제공일 당일 취소 또는 인력 배정 완료 이후에는 환불이 제한될 수 있습니다.',
              '당사 사정으로 서비스 제공이 불가능한 경우 전액 환불됩니다.',
            ].map((item, idx) => (
              <li key={idx} className="flex items-start space-x-2">
                <span className="w-1.5 h-1.5 rounded-full bg-[#C4A574] mt-2 flex-shrink-0"></span>
                <p className="text-gray-600 text-sm leading-relaxed">{item}</p>
              </li>
            ))}
          </ul>
        </div>

        {/* 문의 */}
        <div className="text-center">
          <p className="text-gray-500 text-sm mb-2">결제 관련 문의</p>
          <a
            href="tel:010-2133-5998"
            className="inline-flex items-center space-x-2 text-gray-900 font-bold text-lg hover:text-[#C4A574] transition-colors cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            <span>010-2133-5998</span>
          </a>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#FAF8F5] border-t border-gray-100 py-8 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <p className="text-gray-500 text-xs leading-relaxed">
            <span className="font-semibold text-gray-700">상호명:</span> 청파&nbsp;&nbsp;|&nbsp;&nbsp;
            <span className="font-semibold text-gray-700">대표자:</span> 김우근&nbsp;&nbsp;|&nbsp;&nbsp;
            <span className="font-semibold text-gray-700">사업자등록번호:</span> 602-15-69885
            <br className="md:hidden" />
            <span className="hidden md:inline">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span className="font-semibold text-gray-700">주소:</span> 경상북도 구미시 인동32길 22-9, 4층(진평동)
            <br className="md:hidden" />
            <span className="hidden md:inline">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span className="font-semibold text-gray-700">전화:</span> 010-2133-5998
          </p>
          <p className="text-gray-400 text-xs mt-3">© 2025 청파. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
